import {
    Dimension,
    Pair,
    Point,
    QuadrangleVertex,
    QuadrangleVertices,
    UnitValueCalculator,
    X,
    Y
} from '../abstract-units';
import {Cell} from '../cell';
import {BoxEdge} from '../edge';
import {CellAreaDefinition} from './area-definition';
import {CellAreaType} from './cell-area-type';

export class CellArea {

    public static isSameCellDockingArea(area1: CellArea, area2: CellArea): boolean {
        const isSameArea: boolean = area1 === area2;
        const areBothAreasDefined: boolean = !!area2 && !!area1;
        const isEdgeType: boolean = areBothAreasDefined
            && area1.type === area2.type
            && area2.type === CellAreaType.EDGE;
        const isSameEdge: boolean = isEdgeType
            && area1.cell.edges[area1.boxEdge] === area2.cell.edges[area2.boxEdge];

        return isSameArea || isEdgeType && isSameEdge;
    }

    public type: CellAreaType;
    public boxEdge: BoxEdge;
    public cell: Cell;

    private definition: CellAreaDefinition;
    private vertices: QuadrangleVertices;
    private edges: Array<Pair<Point>>;

    constructor(areaDef: CellAreaDefinition, cell: Cell) {
        this.type = areaDef.type;
        this.boxEdge = areaDef.boxEdge;
        this.definition = areaDef;
        this.cell = cell;

        if (cell) {
            this.initByCell(cell);
        }
    }

    public isPointInArea(point: Point): boolean {
        const [x, y] = point;

        // Ray tracing method
        return this.edges.reduce((isInside: boolean, edge: Pair<Point>): boolean => {
            const [vertex1, vertex2] = edge;
            const intersect: boolean = ((vertex1[Y] > y) !== (vertex2[Y] > y))
                && (x < (vertex2[X] - vertex1[X]) * (y - vertex1[Y]) / (vertex2[Y] - vertex1[Y]) + vertex1[X]);

            return intersect ? !isInside : isInside;
        }, false);
    }

    private initByCell(cell: Cell): void {
        const vertices = this.definition.vertices
            .map(pointDef => pointDef
                .map(
                    (calc: UnitValueCalculator, axis: Dimension) => calc(cell.display.size[axis])
                ) as Point
            ) as QuadrangleVertices;

        this.vertices = vertices;
        this.edges = [
            // TOP
            [vertices[QuadrangleVertex.TOP_LEFT], vertices[QuadrangleVertex.TOP_RIGHT]],
            // RIGHT
            [vertices[QuadrangleVertex.TOP_RIGHT], vertices[QuadrangleVertex.BOTTOM_RIGHT]],
            // BOTTOM
            [vertices[QuadrangleVertex.BOTTOM_LEFT], vertices[QuadrangleVertex.BOTTOM_RIGHT]],
            // LEFT
            [vertices[QuadrangleVertex.TOP_LEFT], vertices[QuadrangleVertex.BOTTOM_LEFT]]
        ];
    }

}
